import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

import ChooseDate from "./ChooseDate";

class Export extends React.Component {
  state = { showModal: false };

  render() {
    const { className, title } = this.props;

    return [
      <a
        key="button"
        className={className}
        style={{ marginBottom: 5 }}
        onClick={this.toggleShowModal}
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && this.toggleShowModal()}
      >
        {title}
      </a>,
      <ChooseDate
        key="modal"
        visible={this.state.showModal}
        onClose={this.toggleShowModal}
        onExport={this.handlerExport}
      />
    ];
  }

  toggleShowModal = () => this.setState({ showModal: !this.state.showModal });

  handlerExport = (fromDate, toDate) => {
    const params = this.props.params;

    params.start = fromDate;
    params.end = toDate;

    const { warningUrl, warningParams, warningMessage, messageError } = this.props;

    if (!warningUrl) {
      this.runExport(params);
      return;
    }

    // records matched by the warning request are excluded from the export,
    // give the user a chance to back out before it is queued
    axios
      .get(
        warningUrl +
          "?" +
          decodeURIComponent(
            $.param({ ...warningParams, start: fromDate, end: toDate })
          )
      )
      .then(({ data }) => {
        const count = data.length;

        if (count > 0 && !window.confirm(warningMessage.replace("{count}", count))) {
          return;
        }

        this.runExport(params);
      })
      .catch(() => {
        toastr.error(messageError);
      });
  };

  runExport = params => {
    this.toggleShowModal();

    const { url, messageSuccess, messageError } = this.props;

    axios
      .get(url + "?" + decodeURIComponent($.param(params)))
      .then(() => {
        toastr.info(messageSuccess);
      })
      .catch(() => {
        toastr.error(messageError);
      });
  };
}

Export.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  messageSuccess: PropTypes.string,
  messageError: PropTypes.string,
  url: PropTypes.string.isRequired,
  params: PropTypes.object,
  warningUrl: PropTypes.string,
  warningParams: PropTypes.object,
  warningMessage: PropTypes.string
};

Export.defaultProps = {
  className: "btn btn-indigo btn-raised btn-block",
  title: "EXPORT",
  messageSuccess:
    'Your Excel Export will be generated shortly, an email with a link will be sent and the file will be available in your My Downloads.',
  messageFailed: "Unable to export it at this time",
  params: {},
  warningParams: {},
  warningMessage:
    "WARNING: {count} record(s) in this date range will NOT be included in the export. Do you want to continue?"
};

export default Export;
